import { query, mutation } from '@/services/graphql';
import * as operations from './operations';

export default {
  getCourseUnitList(variables = {}) {
    return query(operations.COURSE_UNIT_LIST, variables, true);
  },
  getCourseModulelList(variables = {}) {
    return query(operations.COURSE_MODULE_LIST, variables, false, { showErrorMessage: false });
  },
  getCourseData(variables = {}) {
    return query(operations.COURSE_DATA, variables, true, { showErrorMessage: false });
  },
  getExamModelList(variables = {}) {
    return query(operations.EXAM_MODEL_LIST, variables, true, { showErrorMessage: false });
  },
  verifyWrongWord(variables = {}) {
    return query(operations.VERIFY_WRONG_WORD, variables, true);
  },
  getExamOnlineModelList(variables = {}) {
    return query(operations.EXAM_ONLINE_MODEL_LIST, variables, true);
  },
  getExamDetail(variables = {}) {
    return query(operations.EXAM_DETAIL, variables, true);
  },
  getDiffExamDetail(variables = {}) {
    return query(operations.DIFF_EXAM_DETAIL, variables, true);
  },
  getIatUrl(variables = {}) {
    return query(operations.IAT_URL, variables, true);
  },
  checkMatch(variables = {}) {
    return query(operations.CHECK_MATCH, variables, false);
  },
  submitCourseResult(variables = {}) {
    return mutation(operations.COURSE_RESULT, variables, true);
  },
};
